export const landingColors = {
  white: "#FFFFFF",
  darkGray: "#555",
  smoke: "#F8F9FA",
  black: "#000000",
  blueTimeEditBg: "#f5fbff",
  redTimeEditBg: "#fff1f0",
  label: "#808080",
  mintGreen: "#40e099",
  royalPurple: "#381a75",
  textPurple: "#7A56C3",
  skyBlue: "#2196f3",
  red: "#ea3b0f",
  purpleHaze: "#d15de5",
};
